module.exports = __webpack_public_path__ + "media/images/athletes/1320-25e4cdbb7a38df00b49abc8fc2b2f271.png";